<div class="professional-edit w-100-p">
    <div fxLayout="column" id="register-organizational-professional-image-upload-edit-form_dv">

        <div *ngIf="iEartefactId != null">
            <p>{{eartefact?.name}}</p>
            <button mat-button id="register-organizational-professional-image-upload-edit-form_bt" (click)="uploadSignature()"
                type="submit" color="secundary">Baixar</button>
            <button mat-button id="register-organizational-professional-image-upload-edit-form_bt" (click)="deleteSignature()"
                type="submit" color="warn">Excluir</button>
            
        </div>


        <form [formGroup]="imageUpload" *ngIf="iEartefactId == null">

            <input type="file" accept=".png, .jpg, .jpeg" id="profile-signature-file" (change)="imageChange($event)">
            <button mat-button  id="register-organizational-professional-image-upload-edit-form_bt" (click)="uploadSignature()"
                type="submit">Importar imagem</button>
                
        </form>
    </div>
</div>